// state
import { getReduxStore } from "@state/redux-store";
// network
import socket from "@clockwise/web-commons/src/network/socket";
import { LogSend } from "@network/socket.constants";
// local-storage
import { analyticsUser } from "@state/local-storage";
// util
import { getChromeSite } from "@util/chrome-extension.util";
import { isOnShowLogs, isOnAdvancedUserLogging } from "@util/experiment.util";
import {
  logger,
  Logger,
  ConsoleTransport,
  InMemoryCacheTransport,
  LoggerTransport,
  LogLevel,
} from "@clockwise/client-commons/src/util/logger";
import { SentryTransport, FSTransport } from "@clockwise/web-commons/src/util/logger.util";
export { logger };

export function getSharedMeta() {
  if (process.env.NODE_ENV === "test") {
    return {};
  }

  const userId = analyticsUser.get();
  const chromeSite = getChromeSite();
  const {
    webExtensionVersion,
    googleVersion,
    calendarUrl,
  } = getReduxStore().getState().webExtension;

  return {
    userId,
    chromeSite,
    webExtensionVersion,
    googleVersion,
    calendarUrl,
    webappVersion: process.env.RELEASE,
  };
}

class DDTransport extends LoggerTransport {
  public log(message: string, level: LogLevel, ...metas: any[]) {
    if (!isOnAdvancedUserLogging()) {
      return;
    }

    const cleanMeta: { [key: string]: string } = {};

    metas.forEach((meta: any) => {
      if (meta instanceof Error) {
        cleanMeta["errorMessage"] = meta.message;
        cleanMeta["errorName"] = meta.name;
        cleanMeta["errorStack"] = meta.stack || "";
      } else if (typeof meta === "object") {
        try {
          Object.getOwnPropertyNames(meta).forEach((key) => {
            let value = meta[key];
            if (typeof value !== "string") {
              value = JSON.stringify(meta[key], undefined, "  ");
            }
            cleanMeta[key] = value;
          });
        } catch (err) {
          logger.error("Failed to clean meta", err);
        }
      }
    });

    ddLog(level, message, "webapp", cleanMeta);
  }
}

export function ddLog(
  level: string,
  message: string,
  service: string,
  meta: Record<string, string>,
) {
  return new Promise<void>((resolve) => {
    socket.get().emit(LogSend, {
      level,
      message,
      service,
      meta: { ...getSharedMeta(), ...meta },
    });
    resolve();
  });
}

//////////////////
// Singleton
//////////////////
// override the default getSharedMeta defined by the common Logger
Logger.getSharedMeta = getSharedMeta;

export const sentryTransport = new SentryTransport();
export const inMemoryCacheTransport = new InMemoryCacheTransport();

logger.add(inMemoryCacheTransport);

if (process.env.NODE_ENV !== "production" || isOnShowLogs()) {
  logger.add(new ConsoleTransport());
}

if (process.env.NODE_ENV === "production") {
  logger.add(sentryTransport);
  logger.add(new FSTransport());
  logger.add(new DDTransport());
}
